import React from 'react';
import { useLocation } from 'react-router-dom';

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid } from '@iho-design-system/Loader';

/*
    - components
*/
import FinanceTab from '../components/finance/Tab';
import BankBanner from '../components/finance/bank/Banner';
import BankList from '../components/finance/bank/List';
import BankToolbar from '../components/finance/bank/Toolbar';
import ReportBanner from '../components/finance/report/Banner';
import ReportList from '../components/finance/report/List';
import ReportToolbar from '../components/finance/report/Toolbar';
import SettlementBanner from '../components/finance/settlement/Banner';
import SettlementList from '../components/finance/settlement/List';
import SettlementToolbar from '../components/finance/settlement/Toolbar';

/*
    - api
*/
import getAPI from '../api/get';

const Finance = () => {

    /*
        - defaultData
    */
    const [financeData, setFinanceData] = React.useState({
        bankAccount: '',
        walletBalance: '',
        walletReport: '',
        balance: '',
        creditPayments: ''
    });
    const [searchParameters, setSearchParameters] = React.useState({
        TransType: '-1',
        DocType: '2',
        StartDate: '',
        EndDate: ''
    });
    const [insufficientStatus, setInsufficientStatus] = React.useState(false);
    const [reloadFinance, setReloadFinance] = React.useState('');

    /*
        - alertProps
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {

            let bankAccountParameters = {
                ctrl: 'BankAccount',
                method: 'GetAll',
                query: ''
            }

            let walletBalanceParamters = {
                ctrl: 'UserProfile',
                method: 'GetWalletBalanceEx',
                query: ''
            }

            let walletReportParameters = {
                ctrl: 'UserProfile',
                method: 'WalletReport',
                query: '?PageIndex=1&PageSize=10&TransType=-1&DocType=2&StartDate='
            };

            let balanceParameters = {
                ctrl: 'Financial',
                method: 'GetAllBalances',
                query: ''
            }

            let creditPaymentsParameters = {
                ctrl: 'Financial',
                method: 'GetCreditPayments',
                query: '?ServiceType=1'
            }

            setFinanceData({
                bankAccount: await getAPI(bankAccountParameters),
                walletBalance: await getAPI(walletBalanceParamters),
                walletReport: await getAPI(walletReportParameters),
                balance: await getAPI(balanceParameters),
                creditPayments: await getAPI(creditPaymentsParameters)
            });
        }
        fetchData();
    }, [reloadFinance]);

    const insufficientStatusProps = insufficientStatusProps => {
        setInsufficientStatus(insufficientStatusProps);
    }

    /*
        - reloadFinanceProps
    */
    const reloadFinanceProps = (reloadFinanceProps) => {
        setReloadFinance(reloadFinanceProps);
    }

    /*
        - searchProps
    */
    const searchProps = async (searchProps) => {
        if (searchProps.section === 'report') {
            let walletReportParameters = {
                ctrl: 'UserProfile',
                method: 'WalletReport',
                query: ''
            };
            walletReportParameters.query = `?PageIndex=1&PageSize=10&TransType=${searchProps.TransType}&DocType=${searchProps.DocType}&StartDate=${searchProps.StartDate}&EndDate=${searchProps.EndDate}`;
            setSearchParameters(searchProps);
            setFinanceData({
                ...financeData,
                walletReport: await getAPI(walletReportParameters)
            });
        }
        if (searchProps.section === 'settlement') {
            let creditPaymentsParameters = {
                ctrl: 'financial',
                method: 'GetCreditPayments',
                query: ''
            };
            creditPaymentsParameters.query = `?StartDate=${searchProps.startDate}&EndDate=${searchProps.endDate}&ServiceType=${searchProps.serviceType}`;
            setSearchParameters(searchProps);
            setFinanceData({
                ...financeData,
                creditPayments: await getAPI(creditPaymentsParameters)
            });
        }
    }

    /*
        - paginationProps
    */
    const paginationProps = async (paginationProps) => {
        let parameters = {
            ctrl: 'UserProfile',
            method: 'WalletReport',
            query: '',
            PageIndex: '1',
            PageSize: '10',
            TransType: '-1',
            DocType: '2',
            StartDate: ''
        };
        if (Math.ceil(financeData.walletReport.data.TotalItems / financeData.walletReport.data.PageSize) >= financeData.walletReport.data.PageIndex + paginationProps && (financeData.walletReport.data.PageIndex + paginationProps) >= 1) {
            parameters.query = `?PageIndex=${financeData.walletReport.data.PageIndex + paginationProps}&PageSize=10&TransType=${searchParameters.TransType}&DocType=${searchParameters.DocType}&StartDate=${searchParameters.StartDate}&EndDate=${searchParameters.EndDate}`;
            setFinanceData({
                ...financeData,
                walletReport: await getAPI(parameters)
            });
        }
    }

    /*
        - tabsLocation
    */
    const location = useLocation();
    let pageTab = '';
    if (location.pathname === '/finance/report') {
        pageTab = 'report';
    }
    if (location.pathname === '/finance/settlement') {
        pageTab = 'settlement';
    }
    if (location.pathname === '/finance/bank') {
        pageTab = 'bank';
    }

    /*
        - componentData
    */
    let BankbannerData = []
    BankbannerData.bankAccount = financeData.bankAccount;

    let bankToolbarData = [];
    bankToolbarData.bankAccount = financeData.bankAccount;

    let bankListData = [];
    bankListData.bankAccount = financeData.bankAccount;

    let settlementBannerData = [];
    settlementBannerData.balance = financeData.balance;
    settlementBannerData.insufficientStatus = insufficientStatus;

    let settlementListData = [];
    settlementListData.creditPayments = financeData.creditPayments;
    settlementListData.balance = financeData.balance;

    let reportBannerData = [];
    reportBannerData.walletBalance = financeData.walletBalance;
    reportBannerData.bankAccount = financeData.bankAccount;
    reportBannerData.balance = financeData.balance;

    let reportListData = [];
    reportListData.walletReport = financeData.walletReport;

    return (
        <React.Fragment>
            <Container
                size='lg'>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            <FinanceTab />
                        </Grid.Item>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            {pageTab === 'report' &&
                                <ReportBanner
                                    props={reportBannerData}
                                    alertProps={alertProps}
                                    reloadFinanceProps={reloadFinanceProps} />
                            }
                            {pageTab === 'settlement' &&
                                <SettlementBanner
                                    props={settlementBannerData}
                                    alertProps={alertProps}
                                    reloadFinanceProps={reloadFinanceProps} />
                            }
                            {pageTab === 'bank' &&
                                <React.Fragment>
                                    <BankBanner
                                        props={BankbannerData} />
                                </React.Fragment>
                            }
                        </Grid.Item>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            {pageTab === 'report' &&
                                <ReportToolbar
                                    searchProps={searchProps} />
                            }
                            {pageTab === 'settlement' &&
                                <SettlementToolbar
                                    searchProps={searchProps} />
                            }
                            {pageTab === 'bank' &&
                                <BankToolbar
                                    props={bankToolbarData}
                                    alertProps={alertProps}
                                    reloadFinanceProps={reloadFinanceProps} />
                            }
                        </Grid.Item>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            {pageTab === 'report' &&
                                <ReportList
                                    props={reportListData}
                                    paginationProps={paginationProps} />
                            }
                            {pageTab === 'settlement' &&
                                <SettlementList
                                    props={settlementListData}
                                    insufficientStatusProps={insufficientStatusProps}
                                    alertProps={alertProps}
                                    reloadFinanceProps={reloadFinanceProps} />
                            }
                            {pageTab === 'bank' &&
                                <React.Fragment>
                                    <BankList
                                        props={bankListData}
                                        alertProps={alertProps}
                                        reloadFinanceProps={reloadFinanceProps} />
                                </React.Fragment>
                            }
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Container>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Finance;